// Mock data for Upgrade Water

export const heroSlides = [
  {
    id: 1,
    title: 'Make Water',
    highlight: 'out of Air!',
    subtitle: 'Patented Atmospheric Water Generation Technology',
    description: 'Engineered for luxury hotels and premium yachts. Harvest pure drinking water directly from air humidity.',
    image: 'https://images.unsplash.com/photo-1535868118629-f37bcd69ff59',
    cta: 'Book a Demo'
  },
  {
    id: 2,
    title: 'Onboard Any',
    highlight: 'Luxury Yacht',
    subtitle: '100% Pure Ozonated Water',
    description: 'End dependence on shore water. Generate crystal-clear drinking water at sea, powered by ocean humidity.',
    image: 'https://images.unsplash.com/photo-1605281317010-fe5ffe798166',
    cta: 'Explore Marine Range'
  },
  {
    id: 3,
    title: 'Redefine Hotel',
    highlight: 'Hospitality',
    subtitle: 'Sustainability meets Luxury',
    description: 'Serve guests premium mineral water from the air itself. Reduce plastic waste and elevate your brand story.',
    image: 'https://images.unsplash.com/photo-1630587148265-761cbd139043',
    cta: 'Hotel Solutions'
  },
  {
    id: 4,
    title: 'Purest Form',
    highlight: 'of Water?',
    subtitle: 'Water Made From Air',
    description: 'A 4-step patented filtration process delivers oxygenated, mineral-balanced drinking water with unmatched taste.',
    image: 'https://images.unsplash.com/photo-1519873174361-37788c5a73c7',
    cta: 'How It Works'
  }
];

export const products = [
  {
    id: 'aqua-suite',
    name: 'Aqua Suite',
    tagline: 'Designed for Hotel Guest Rooms',
    description: 'A silent, compact split unit engineered for luxury suites. The outdoor module captures humidity while the elegant indoor dispenser serves chilled, ozonated water directly to guests — no plumbing required.',
    image: 'https://images.unsplash.com/photo-1534616042650-80f5c9b61f09',
    capacity: '30 L / day',
    tag: 'Best for Hotels',
    color: 'from-sky-500 to-cyan-600'
  },
  {
    id: 'marine-pro',
    name: 'Marine Pro',
    tagline: 'Built for Yachts & Luxury Vessels',
    description: 'Marine-grade atmospheric water generator with anti-corrosive finish. Thrives in high-humidity ocean environments, giving your yacht unlimited fresh water without the tanks or the taste of salt.',
    image: 'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a',
    capacity: '80 L / day',
    tag: 'Yacht Edition',
    color: 'from-teal-500 to-cyan-600'
  },
  {
    id: 'grand-hydra',
    name: 'Grand Hydra',
    tagline: 'For Resorts, Spas & Superyachts',
    description: 'A mass-scale water generating solution for high-demand hospitality. Self-contained, energy-efficient and completely off-grid capable — the flagship for properties that demand the very best.',
    image: 'https://images.unsplash.com/photo-1549294413-26f195200c16',
    capacity: '500 L / day',
    tag: 'Flagship',
    color: 'from-blue-600 to-indigo-700'
  }
];

export const testimonials = [
  {
    id: 1,
    quote: 'Installing Upgrade Water across our beachfront suites has become one of our most talked-about guest amenities. Reviews mention the water quality by name — it is remarkable.',
    name: 'Aarav Menon',
    role: 'General Manager',
    company: 'The Blue Palm Resort, Goa'
  },
  {
    id: 2,
    quote: 'On a 40-metre yacht, every litre of stored water counts. The Marine Pro made our tanks nearly redundant. Guests are stunned when we tell them where the water comes from.',
    name: 'Captain Lorenzo Vitali',
    role: 'Yacht Captain',
    company: 'M/Y Serenissima, Monaco'
  },
  {
    id: 3,
    quote: 'We removed 180,000 plastic bottles from operations in the first year. The ROI wasn\u2019t just financial — it changed how our guests perceive us as a brand.',
    name: 'Sofia Herrera',
    role: 'Sustainability Director',
    company: 'Aurelia Hotels Group'
  },
  {
    id: 4,
    quote: 'The taste is genuinely different — soft, clean, with a mineral finish. Our sommelier now pairs it with tasting menus instead of imported bottled water.',
    name: 'Chef Rohan Khanna',
    role: 'Executive Chef',
    company: 'Meridian by the Sea'
  },
  {
    id: 5,
    quote: 'Silent, reliable and stunning to look at. The Aqua Suite disappears into our interior design and delivers flawlessly, day after day.',
    name: 'Isabelle Laurent',
    role: 'Interior Design Lead',
    company: 'Coastal Collection Hotels'
  }
];

export const filtrationSteps = [
  {
    step: '01',
    title: 'Air Intake & Pre-Filter',
    description: 'Ambient air is drawn in and passed through a medical-grade filter, removing dust, pollen and airborne particulates before condensation begins.'
  },
  {
    step: '02',
    title: 'Condensation Chamber',
    description: 'Humidity is condensed into raw water using a patented, energy-efficient cooling cycle designed for coastal and high-humidity environments.'
  },
  {
    step: '03',
    title: 'Multi-Stage Purification',
    description: 'Pre-carbon, sediment and mineral-balancing filters remove up to 95% of impurities while restoring essential minerals for perfect taste.'
  },
  {
    step: '04',
    title: 'Ozonation & Dispensing',
    description: 'Ozone \u2014 3000x more powerful than chlorine \u2014 sterilises every drop. Water is then served chilled, hot or ambient at the touch of a button.'
  }
];

export const useCases = [
  {
    id: 'hotels',
    title: 'Luxury Hotels & Resorts',
    image: 'https://images.unsplash.com/photo-1630587148265-761cbd139043',
    points: [
      'Eliminate single-use plastic bottles in guest rooms',
      'In-room premium water dispensers, silent by design',
      'Central bottling stations for restaurants & spas',
      'Turnkey installation with 24/7 service SLAs'
    ]
  },
  {
    id: 'yachts',
    title: 'Yachts & Superyachts',
    image: 'https://images.unsplash.com/photo-1523496922380-91d5afba98a3',
    points: [
      'Marine-grade, corrosion-resistant construction',
      'Thrives on the ocean\u2019s natural humidity',
      'Reduce fresh-water tank load and shore dependency',
      'Compact footprint engineered for tight spaces'
    ]
  }
];

export const stats = [
  { value: '2M+', label: 'Litres Generated' },
  { value: '180+', label: 'Properties Served' },
  { value: '40+', label: 'Yachts Onboard' },
  { value: '99.9%', label: 'Purity Rating' }
];

export const brands = [
  'The Blue Palm', 'Aurelia Hotels', 'Meridian', 'Coastal Collection', 'M/Y Serenissima', 'Azure Bay'
];
